import React, { Component } from "react";
import * as Const from "../Constant";
import Box from '@mui/material/Box';

import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import Checkbox from '@mui/material/Checkbox';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import PlayCircleOutlinedIcon from '@mui/icons-material/PlayCircleOutlined';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';


import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import FavoriteBorder from '@mui/icons-material/FavoriteBorder';
import Favorite from '@mui/icons-material/Favorite';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import ChoixSelection from "./ChoixSelection";
import ChoixCondition from "./ChoixCondition";
import ChoixPeriode from "./ChoixPeriode";
import Divider from '@mui/material/Divider';
import AutoFixHighOutlinedIcon from '@mui/icons-material/AutoFixHighOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PanelResultat from "./PanelResultat";
import HelpCenterOutlinedIcon from '@mui/icons-material/HelpCenterOutlined';
import Drawer from '@mui/material/Drawer';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Switch from '@mui/material/Switch';
import { BlurCircular, QueuePlayNext, RotateRight } from "@mui/icons-material";
import Tooltip from '@mui/material/Tooltip';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Rating from '@mui/material/Rating';



export default class DialogFicheCourse extends Component {

    constructor(props) {
        super(props);
        this.state = {
         open:this.props.open,
         data:this.props.data
        }   
    }

    componentWillReceiveProps(props) {
      this.setState({ open: props.open})
      this.setState({ data: props.data})
    }

    componentDidMount() {
     
    }

    close= () => {
      this.props.closeFicheCourse()
    }

    plus = (partant) => {
      var div = document.getElementById("blocMetrics_" + partant.partant.id);
        if (div.style.display === "none" || div.style.display === "") {
            div.style.display = "block"; // Afficher
        } else {
            div.style.display = "none";  // Cacher
        }
    }

    onMouseOver = (partant) => {
      var div = document.getElementById("card_" + partant.partant.id);
      if (div) {
        div.style.backgroundColor = "#f0f0f0";
        div.style.zIndex = "2"; // Mettre le div en avant
        div.style.transform = "scale(1.02)"; // Agrandir légèrement
        div.style.transition = "transform 0.2s"; // Ajouter une transition douce
      }
    };
    
    onMouseLeave = (partant) => {
      var div = document.getElementById("card_" + partant.partant.id);
      if (div) {
        div.style.backgroundColor = "#ffffff";
        div.style.zIndex = "1"; // Revenir à la position normale
        div.style.transform = "scale(1)"; // Remettre à la taille initiale
      }
    };
    cache = (partant) => {   
      var div = document.getElementById("card_" + partant.partant.id);
        if (div.style.display === "none" || div.style.display === "") {
            div.style.display = "block"; // Afficher
        } else {
            div.style.display = "none";  // Cacher
        }
    }

    render() {
        return (
          
            <Dialog
              open={this.state.open}
              onClose={this.close}
              fullScreen
              fullWidth
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                <span>test</span>
              </DialogTitle>
              <IconButton
                aria-label="close"
                onClick={this.close}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
              <CloseIcon style={{color:"black"}} />
              </IconButton>
              <Divider/>
              <DialogContent>
              <Box sx={{ width: '100%'}}>
              <div>
              <div style={{display:"flex", marginLeft:"3em", marginRight:"3em"}}>
                    <div style={{flex:"2"}}>
                      
                    </div>

                    <div id="indicateurs" style={{flex:"1.5"}}>
                      <div style={{display:"flex"}}>
                        <div style={{flex:"1.5"}}>
                            <center>
                              <span class="lato-bold" style={{fontSize:"13px"}}>FORME</span>
                            </center>
                        </div>
                        <div style={{flex:"1.5"}}>
                            <center>
                              <span class="lato-bold" style={{fontSize:"13px"}}>POTENTIEL</span>
                            </center>
                        </div>
                        <div style={{flex:"1.5"}}>
                            <center>
                              <span class="lato-bold" style={{fontSize:"13px"}}>CONDITION</span>
                            </center>
                        </div>
                        <div style={{flex:"1.5"}}>
                          <center>
                            <span class="lato-bold" style={{fontSize:"13px"}}>POPULARITÉ</span>
                          </center>
                        </div>
                       
                        <div style={{flex:"1"}}>
                          
                        </div>
                        <div style={{flex:"1"}}>
                          
                        </div>
                      </div>
                    </div>
                  </div>

              </div>


              {this.state.data.participant != null && this.state.data.participant.map((partant) => (

              <Card id={"card_" + partant.partant.id} style={{marginTop:"0.5em", marginLeft:"3em", marginRight:"3em", cursor:"pointer", display:"block", height:"60px", zIndex: 1, transition: "transform 0.2s"}} variant="outlined"
              onMouseLeave={() => this.onMouseLeave(partant)} // Utiliser onMouseLeave
              onMouseEnter={() => this.onMouseOver(partant)} // Utiliser onMouseEnter
              >
                <CardContent style={{padding:"5px"}}>
                  <div style={{display:"flex", height:"100%"}}>
                    <div style={{flex:"2"}}>
                      <span>{partant.partant.nom}</span><br>
                      </br><span>dg</span>
                    </div>

                    <div id="indicateurs" style={{flex:"1.5"}}>
                      <div style={{display:"flex", height:"100%"}}>
                        <div style={{flex:"1.5", marginTop:"0.5em"}}>
                            <center>
                              <Rating name="read-only" max={4} value={2.5} precision={0.5} readOnly />
                            </center>
                        </div>
                        <div style={{flex:"1.5", marginTop:"0.5em"}}>
                            <center>
                              <Rating name="read-only" max={4} value={1} precision={0.5} readOnly />
                            </center>
                        </div>
                        <div style={{flex:"1.5", marginTop:"0.5em"}}>
                            <center>
                              <Rating name="read-only" max={4} value={2.5} precision={0.5} readOnly />
                            </center>
                        </div>
                        <div style={{flex:"1.5", marginTop:"0.5em"}}>
                        <center>
                          4
                        </center>
                        </div>
                       
                        <div style={{flex:"1", marginTop:"0.5em"}}>
                          <Button onClick={() => this.plus(partant)}> Plus </Button>
                        </div>
                        <div style={{flex:"1", marginTop:"0.5em"}}>
                          <Button onClick={() => this.cache(partant)}> Cacher </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id={"blocMetrics_" + partant.partant.id} style={{backgroundColor:"black", display:"none"}}>
                    <span>hello</span>
                  </div>
                </CardContent>
              </Card>

              ))}
      
              </Box>    
              </DialogContent>
              
            </Dialog>

            

        )
    }
}